<template>
  <div class="drawer">
    <el-drawer
      size="1600px"
      title="设置员工月目标"
      :visible.sync="drawerStatus"
      @close="handleClose"
    >
      <div style="padding-bottom: 40px; height: 100%; overflow: scroll">
        <el-row class="row">
          <el-col :span="24">
            <span class="label" style="vertical-align: middle">所选月份：</span>
            <span class="value" style="width: 656px">
              {{ $public.FTime(pkMonth, "YYYY-MM") }}
            </span>
          </el-col>
        </el-row>
        <el-row class="row">
          <el-col :span="6" style="display: flex">
            <span class="label"
              >门店：{{ $public.getShopNameById(shopId) }}</span
            >
          </el-col>
          <el-col :span="4" style="display: flex">
            <span class="label">岗位：{{ staffList[postId] }}</span>
          </el-col>
        </el-row>
        <el-row class="row" style="margin-left: 50px">
          <el-col :span="6">
            <span>门店总目标：{{ targetObj.target }}</span>
          </el-col>
          <el-col :span="12">
            每周目标：
            <span v-for="(item, index) in targetObj.target_week" :key="index">
              第{{ index + 1 }}周: {{ item }}</span
            >
          </el-col>
        </el-row>
        <div class="boxView">
          <el-row class="row">
            <el-col :span="24">
              <span class="label">员工业绩目标：</span>
              <span class="value">
                <div class="table">
                  <div class="tableRow">
                    <div class="cell">员工名称</div>
                    <div class="cell">门店</div>
                    <div class="cell">岗位</div>
                    <!-- <div class="cell">上月业绩</div> -->
                    <div class="cell">本月目标</div>
                    <div
                      class="cell"
                      v-for="(item, index) in targetObj.target_week"
                      :key="index"
                    >
                      第{{ index + 1 }}周
                    </div>
                  </div>

                  <div
                    class="tableRow"
                    v-for="(shop, index) in data"
                    :key="index"
                  >
                    <div class="cell">
                      {{ shop.staff_info && shop.staff_info.staff_name }}
                    </div>
                    <div class="cell">
                      {{
                        $public.getShopNameById(
                          shop.staff_info.shop_info.shop_id
                        )
                      }}店
                    </div>
                    <div class="cell">
                      {{ staffList[shop.staff_info.staff_type] }}
                    </div>
                    <!-- <div class="cell">
                      {{ shop.last_month_target }}
                    </div> -->
                    <div class="cell">
                      <!-- {{ shop.month_target }} -->
                      <el-input
                        size="mini"
                        v-model.number="shop.month_target"
                        @input="changeMonth(shop,index,index1)"
                        style="width: 80px"
                      ></el-input>
                    </div>
                    <div
                      class="cell"
                      v-for="(item, indexA) in shop.week_target_list"
                      :key="indexA"
                    >
                    <div>{{ shop.week_target_list[indexA] }}</div>
                      <!-- <el-input
                        size="mini"
                        v-model.number="shop.week_target_list[indexA]"
                        @change="changeTarget(shop, index, indexA)"
                        style="width: 80px"
                      ></el-input> -->
                    </div>
                    <!-- <div class="cell">
                      <el-input
                        size="mini"
                        clearable
                        v-model="shop.proportion"
                        style="width: 80px"
                        @input="change"
                        @blur="changeProportion(shop, index)"
                      ></el-input
                      >%
                    </div> -->
                  </div>
                </div>
              </span>
            </el-col>
          </el-row>
        </div>

        <div style="height: 40px; width: 100%"></div>
        <div class="btnBox">
          <div class="btnItem" @click="handleClose">取消</div>
          <div class="btnItem submit" @click="submit_check">确定</div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { weekdays } from "moment";
import shopList from "../../../util/shopList";
export default {
  data() {
    return {
      data: [],
      // 月份
      pkMonth: sessionStorage.getItem("pkMonth"),
      staffList: ["", "医生", "医助", "美容师", "美助", "销售"],
      shopList: shopList,
      drawerStatus: true,
      selectedList: [],
      shop_setting_list: [],
      staff_setting_list: [],
      // dialog
      dialog_state: false,
      dialog_radio: 1,
      dialog_money: "",
      dialog_rate: "",
      targetObj: {},
      index1:0,
    };
  },
  props: {
    staffArr: {
      default: [],
    },
    shopId: {
      default: "",
    },
    postId: {
      default: "",
    },
    datas: {
      default: {},
    },
  },
  computed: {},
  mounted() {
    console.log(this.staffArr, "pkMonth");
    console.log(this.datas, "datas");
    this.getInfo(this.datas.shop_setting_list, this.shopId);
    // 初始化数据
    this.initSatff(this.staffArr);
  },
  methods: {
    getInfo(arr = [], id = "") {
      let targetObj;
      arr.forEach((item) => {
        if (item.shop_info.shop_id == id) {
          targetObj = item.department_target;
        }
      });
      let obj = {
        target: "",
        target_week: "",
      };
      if (this.postId == "5") {
        obj.target = targetObj.sale_target;
        obj.target_week = targetObj.sale_target_week;
      } else if (this.postId == "1") {
        obj.target = targetObj.medical_target;
        obj.target_week = targetObj.medical_target_week;
      } else if (this.postId == "3") {
        obj.target = targetObj.washing_target;
        obj.target_week = targetObj.washing_target_week;
      }
      console.log(obj);
      this.targetObj = obj;
    },
    // 改变月目标
    changeMonth(row, index) {
      // let month_target=(this.targetObj.target-row.month_target)/(this.data.length-1);
      this.data.forEach((item, index1) => {
        // if (index !== index1) {
        //   item.month_target = month_target;
        // }
        let arr=[]
        this.targetObj.target_week.map((itema)=>{
          arr.push(Math.floor((itema/this.targetObj.target)*(item.month_target)))
        })
        console.log(arr);
        item.week_target_list=arr
        

      });
    },
    // //改变周目标
    // changeTarget(row, index, indexA) {
    //   let week_target =
    //     (this.targetObj.target_week[indexA] - row.week_target_list[indexA]) /
    //     (this.data.length - 1);
    //   this.data.forEach((item, index1) => {
    //     if (index !== index1) {
    //       item.week_target_list[indexA] = week_target;
    //     }
    //   });
    //   let sum = 0;
    //   row.week_target_list.forEach((item) => {
    //     sum += item;
    //   });
    //   row.month_target = sum;
    // },
    changefirstWeek(e) {
      console.log(e);
    },
    change() {
      this.$forceUpdate();
    },
    // 占比
    // changeProportion(row, index) {
    //   console.log(row, "-------------row", index);
    //   console.log(row.proportion, "row.proportion1");
    //   console.log(row.proportion / 100, "row.proportion2");
    //   console.log((row.proportion / 100).toFixed(2), "row.proportion3");
    //   console.log((row.proportion / 100).toFixed(4), "row.proportion4");
    //   let sum = 0;
    //   if (row.proportion == 0) {
    //     row.week_target_list.forEach((item, index) => {
    //       row.week_target_list[index] =
    //         this.targetObj.target_week[index] *
    //         (row.proportion / 100).toFixed(4);
    //     });

    //     row.week_target_list.forEach((item) => {
    //       sum += item;
    //     });
    //   }
    //   row.week_target_list.forEach((item, index) => {
    //     row.week_target_list[index] =
    //       this.targetObj.target_week[index] * (row.proportion / 100).toFixed(4);
    //   });
    //   row.week_target_list.forEach((item) => {
    //     sum += item;
    //   });
    //   for (var i = 0; i < this.data.length; i++) {
    //     if (i !== index) {
    //       this.data[i].proportion =
    //         (100 - row.proportion) / (this.data.length - 1);
    //       let sum = 0;
    //       for (var j = 0; j < this.data[i].week_target_list.length; j++) {
    //         this.data[i].week_target_list[j] =
    //           this.targetObj.target_week[j] *
    //           (this.data[i].proportion / 100).toFixed(4);
    //         sum += this.data[i].week_target_list[j];
    //       }
    //       this.data[i].month_target = sum;
    //       console.log(this.data[i].month_target, "月目标");
    //     }
    //   }
    //   console.log(this.data, "data");

    //   row.month_target = sum;
    // },
    initSatff(arr = []) {
      this.data = arr;
      console.log(arr, "arr");
    },
    handleClose() {
      this.$emit("submit", { type: "close" });
    },
    submit_check() {
      this.datas.staff_setting_list.forEach((item, index) => {
        this.data.forEach((itema) => {
          if (item.staff_info.staff_name == itema.staff_info.staff_name) {
            //添加属性用来标记相同的对象
            item.isRepeat = true;
          }
        });
      });
      this.datas.staff_setting_list.forEach((item) => {
        //通过标记筛选对象
        if (!item.isRepeat) {
          console.log(item.staff_info.staff_name, "index");
          this.data.push(item);
        }
      });
      let params = {
        id: this.datas.id,
        month_info: this.datas.month_info,
        trace_list: this.datas.trace_list,
        week_setting_list: this.datas.week_setting_list,
        shop_setting_list: this.datas.shop_setting_list,
        staff_setting_list: this.data,
      };
      console.log(params);
      let loading = this.$loading();
      this.$http
        .post(
          process.env.VUE_APP_Url9 +
            "api/ShopPerformancePKService/AddShopPerformanceSetting",
          params
        )
        .then((res) => {
          loading.close();
          if (res.code == 0) {
            this.$message({
              message: "设置成功",
              type: "success",
            });
            this.$emit("submit", { type: "success" });
          }
        });
    },
  },
};
</script>

<style scoped lang="scss">
.drawer {
  width: 0;
  padding: 0 0 0 0;
  ::v-deep.el-drawer {
    .el-drawer__header {
      margin-bottom: 10px;
    }
    .boxView {
      .row {
        padding: 20px 20px 0;
        float: none;
        font-size: 20px;
        .label {
          display: inline-block;
          width: 150px;
          text-align: right;
          font-size: 14px;
          color: $fontColor;
          vertical-align: top;
        }
        .value {
          display: inline-block;
          font-size: 14px;
          color: $fontColor;
          .table {
            border: 1px solid #e7e7e7;
            border-right: 0;
            border-bottom: 0;
            width: 1400px;
            margin-left: 10px;
            .tableRow {
              display: flex;
              border-bottom: 1px solid #e7e7e7;
              .cell {
                border-right: 1px solid #e7e7e7;
                height: 50px;
                width: 100%;
                text-align: center;
                padding: 8px 0;
                box-sizing: border-box;
                line-height: 32px;
              }
            }
          }
        }
      }
    }
    .el-drawer__body {
      overflow-y: auto;
      padding-bottom: 30px;
      height: calc(100% - 75px);
    }
    .row {
      padding: 30px 10px 0;
      float: none;
      font-size: 20px;
      .label {
        line-height: 40px;
        display: inline-block;
        width: 120px;
        text-align: right;
        font-size: 14px;
        color: $fontColor;
        vertical-align: top;
      }
      .value {
        display: inline-block;
        font-size: 14px;
        color: $fontColor;
        .table {
          border: 1px solid #e7e7e7;
          border-right: 0;
          border-bottom: 0;
          width: 90%;
          margin-left: 10px;
          .tableRow {
            display: flex;
            border-bottom: 1px solid #e7e7e7;
            .cell {
              border-right: 1px solid #e7e7e7;
              height: 50px;
              width: 100%;
              text-align: center;
              padding: 8px 0;
              box-sizing: border-box;
              line-height: 32px;
              &:last-child {
                width: 200%;
              }
            }
          }
        }
      }
    }
  }
}
.btnBox {
  width: 100%;
  font-size: 14px;
  color: #fff;
  line-height: 40px;
  display: flex;
  position: absolute;
  bottom: 0;
  z-index: 10;
  .btnItem {
    text-align: center;
    width: 100%;
    background-color: #d6d6d6;
    cursor: pointer;
    &.submit {
      background-color: $mainColor;
    }
  }
}
// dialog
.dialogCon {
  .line {
    display: flex;
    padding: 10px 0;
    .label {
      font-size: 14px;
      color: $fontColor;
      vertical-align: middle;
    }
    .value {
    }
  }
}
</style>
